import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24.5 4.875a2.5 2.5 0 0 1 2.5 2.5v15.25a2.5 2.5 0 0 1-2.5 2.5h-19a2.5 2.5 0 0 1-2.5-2.5V7.375a2.5 2.5 0 0 1 2.5-2.5zM28.875 7a4 4 0 0 0-4-4H5.125a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h19.75a4 4 0 0 0 4-4z"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.87",
      d: "M12.815 16.125v3.565H5.31v-3.565c0-1.171.894-2.065 2.065-2.065h3.375c1.171 0 2.065.894 2.065 2.065Zm3.12-5.815h9.38v.005h-9.38zm0 3.75h9.38v.005h-9.38zm0 3.75h3.755v.005h-3.755zM9.062 8c.963 0 1.795.838 1.795 1.843a1.78 1.78 0 0 1-1.794 1.775c-1.038 0-1.878-.84-1.878-1.775 0-.97.88-1.844 1.878-1.844Z"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }